// extracted by mini-css-extract-plugin
export var active = "bp_bd";
export var categories = "bp_bV";
export var category = "bp_bW";
export var icon = "bp_bz";
export var icons = "bp_cW";
export var image = "bp_k";
export var member = "bp_gC";
export var memberTitle = "bp_gD";
export var name = "bp_fF";
export var placeholder = "bp_bb";
export var section = "bp_j";
export var show = "bp_L";
export var subtitle = "bp_b7";
export var team = "bp_gB";